import { CardComponentProps } from "@~/types/types";
import { PrimaryButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import classNames from "classnames";

import styles from "./ReviewsCallToAction.module.scss";

export function ReviewsCallToAction({
  product,
}: Pick<CardComponentProps, "product">) {
  const cx = classNames.bind(styles);

  const { title, writeReviewUrl, isRetired } = product;

  const buttonText = isRetired ? "No longer available" : "Write a review";
  const ariaLabel = isRetired
    ? `${title} is no longer available`
    : `Write a review for ${title}`;

  return (
    <PrimaryButton
      className={cx(
        styles.button,
        isRetired ? styles.retiredProductButton : undefined,
      )}
      tag="a"
      href={writeReviewUrl}
      data-testid="reviews-cta-button"
      aria-label={ariaLabel}
      size="small"
      labelText={buttonText}
      disabled={isRetired}
    />
  );
}
